import { useEffect, useState } from "react";
import confetti from "canvas-confetti";
import { PartyPopper } from "lucide-react";
import { api } from "../../lib/api";

const usd = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

const GoalReached = ({ raised }) => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    confetti({ particleCount: 140, spread: 80, origin: { y: 0.5 }, colors: ["#D4AF37", "#ECC23D", "#F02078", "#FFFFFF"] });
  }, []);
  return (
    <div className="mb-3 rounded-xl p-4 text-white bg-gradient-to-r from-[#F02078] to-[#D4AF37] flex items-start gap-3" data-testid="bethea-goal-reached">
      <PartyPopper className="w-6 h-6 shrink-0" />
      <div>
        <div className="font-serif text-xl">Goal Reached!</div>
        <div className="text-sm">Thank you for helping veterans find home. {usd(raised)} raised and counting.</div>
      </div>
    </div>
  );
};

export const BetheaProgress = () => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/bethea/progress").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const reached = p.raised >= p.goal;
  const pct = Math.min(100, (p.raised / p.goal) * 100);
  return (
    <div className="mt-4 rounded-2xl border border-[#D4AF37]/40 bg-[#000099]/60 p-4" data-testid="bethea-progress">
      {reached && <GoalReached raised={p.raised} />}
      <div className="flex items-end justify-between gap-2">
        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase font-semibold text-[#F02078]">House of Bethea Goal</div>
          <div className="font-serif text-2xl text-[#ECC23D]" data-testid="bethea-raised">{usd(p.raised)} <span className="text-sm text-white/80 font-sans">raised of {usd(p.goal)}</span></div>
        </div>
        <div className="text-sm font-semibold text-white" data-testid="bethea-pct">{Math.round((p.raised / p.goal) * 100)}%</div>
      </div>
      <div className="mt-3 h-3 rounded-full bg-white/10 overflow-hidden">
        <div className={`h-full rounded-full transition-[width] duration-1000 ${reached ? "bg-[#ECC23D]" : "bg-gradient-to-r from-[#D4AF37] to-[#F02078]"}`} style={{ width: `${pct}%` }} data-testid="bethea-bar" />
      </div>
      <div className="text-xs text-white/80 mt-2">{p.donors} {p.donors === 1 ? "supporter" : "supporters"} so far · Every gift helps a veteran find home.</div>
    </div>
  );
};
